import React, { memo } from 'react';

import { Redirect } from 'react-router-dom';

import { useRemoteConfigAccess } from '@src/packages/utils/hooks/remoteConfigs/useRemoteConfigAccess';

import type { RemoteConfigGateProps } from './RemoteConfigGate.types';

const RemoteConfigGate = ({ configKey, children }: RemoteConfigGateProps) => {
  const { isAllowed, isLoaded } = useRemoteConfigAccess(configKey);

  if (!isLoaded) return null;
  if (!isAllowed) return <Redirect to="/" />;
  return <>{children}</>;
};

export default memo(RemoteConfigGate);
